import type { FC } from "react";

import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

import { StyledCellButtonText, StyledIconButton } from "app/components/React/Table/cells/ExpansionButtonCell";
import { translate } from "app/filters/i18nFilter";
import type { IOpenSERPParams } from "app/pages/digital-marketing/keywords-campaigns/reports/shared/Table/TableUtils/RankTrackerTablesTypes";

import { useSerpOverlayContext } from "./SerpOverlay";
import { DEFAULT_SERP_OVERLAY_TRACKING_EVENT } from "./SerpOverlay/constants";

interface ISerpButtonProps {
    serpLinkProps: IOpenSERPParams;
    padding?: string;
    buttonText?: string;
    trackingEventName?: string;
    infoText?: string;
    isDisabled?: boolean;
}

const SerpButtonWrapper = styled(FlexRow)`
    align-items: center;
    margin-top: 16px;
    gap: 8px;
`;

const ButtonWrapper = styled(FlexRow)`
    width: 82px;
    align-items: center;
    justify-content: center;
`;

const SerpButtonInfo = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[400])}
`;

/** Requires SerpOverlayProvider — mounted in KeywordsCampaignsModuleFrame. */
export const SerpButton: FC<ISerpButtonProps> = (props) => {
    const {
        serpLinkProps,
        padding = "5px 8px 5px 4px",
        buttonText = translate("rankTracker.trendReport.table.column.serp.tooltip.button"),
        trackingEventName = DEFAULT_SERP_OVERLAY_TRACKING_EVENT,
        infoText,
        isDisabled,
    } = props;
    const { openSerpOverlay } = useSerpOverlayContext();

    return (
        <SerpButtonWrapper>
            <ButtonWrapper>
                <StyledIconButton
                    height={24}
                    onClick={() => openSerpOverlay(serpLinkProps, trackingEventName)}
                    iconName={"link-out"}
                    padding={padding}
                    isDisabled={isDisabled}
                >
                    <StyledCellButtonText>{buttonText}</StyledCellButtonText>
                </StyledIconButton>
            </ButtonWrapper>
            {infoText ? <SerpButtonInfo>{infoText}</SerpButtonInfo> : null}
        </SerpButtonWrapper>
    );
};
